import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
export function FailedSolutionsSection() {
  const failedSolutions = [{
    attempt: 'Cansarlo hasta que "se apague"',
    why: 'Funciona hoy. Mañana necesitas el doble. Y no estás enseñando calma: estás enseñando agotamiento.'
  }, {
    attempt: 'Darle premios para que se calle',
    why: 'Sin un plan, el premio se vuelve un "silenciador". No construye tolerancia, solo compra segundos.'
  }, {
    attempt: 'Irse "a ver si se acostumbra"',
    why: 'Eso no es entrenamiento. Es exposición sin control. Y en perros sensibles, el pánico se entrena… rápido.'
  }, {
    attempt: 'Volver corriendo cuando llora',
    why: 'Aquí está la parte que duele leer: si vuelves justo en el pico, sin querer, el perro aprende: "mi pánico funciona."'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0
    }
  };
  return <section className="w-full bg-[#F5F3F0] py-16 md:py-24 px-4" data-id="element-3">
      <div className="max-w-5xl mx-auto" data-id="element-4">
        <motion.h2 className="text-3xl md:text-4xl font-bold text-[#2C2C2C] mb-4 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-5">
          Lo que casi todos intentan
        </motion.h2>

        <motion.p className="text-xl text-[#5C5C5C] mb-12 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} data-id="element-6">
          (y por qué no funciona)
        </motion.p>

        <motion.div className="grid grid-cols-1 md:grid-cols-2 gap-6" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} data-id="element-7">
          {failedSolutions.map((solution, index) => <motion.div key={index} className="bg-white rounded-xl p-6 border-2 border-[#C7E0E7]/10" variants={itemVariants} data-id="element-8">
              <div className="flex items-start mb-3" data-id="element-9">
                <XCircleIcon className="h-6 w-6 text-red-500 mr-3 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-10" />
                <h3 className="text-lg font-bold text-[#2C2C2C]" data-id="element-11">
                  {solution.attempt}
                </h3>
              </div>
              <p className="text-[#5C5C5C] leading-relaxed ml-9" data-id="element-12">
                {solution.why}
              </p>
            </motion.div>)}
        </motion.div>

        <motion.div className="mt-12 text-center bg-[#C7E0E7]/10 rounded-2xl p-8" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} data-id="element-13">
          <p className="text-xl font-bold text-[#2C2C2C] mb-3" data-id="element-14">
            La verdad que te libera
          </p>
          <p className="text-lg text-[#5C5C5C] max-w-3xl mx-auto" data-id="element-15">
            Tu perro no está manipulando. Está repitiendo una habilidad que
            nadie le enseñó todavía:{' '}
            <strong className="text-[#2C2C2C]" data-id="element-16">
              estar solo sin entrar en alarma.
            </strong>
          </p>
        </motion.div>
      </div>
    </section>;
}